import e from "./SchemaRailPanel.vue.script.js";
//#region src/schema/SchemaRailPanel.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SchemaRailPanel.vue.js.map